export enum emailChangeTokenTypes {
  FETCH_EMAIL_CHANGE_TOKEN_REQUEST = "FETCH_EMAIL_CHANGE_TOKEN_REQUEST",
  FETCH_EMAIL_CHANGE_TOKEN_SUCCESS = "FETCH_EMAIL_CHANGE_TOKEN_SUCCESS",
  FETCH_EMAIL_CHANGE_TOKEN_FAILURE = "FETCH_EMAIL_CHANGE_TOKEN_FAILURE",
}